import React from "react";
import {
  Button,
  Dialog,
  Card,
  CardBody,
  CardFooter,
  Typography,
  Input,
} from "@material-tailwind/react";
import { useSelector } from "react-redux";

const ListModal = ({
  isOpen,
  handleClose,
  modalData,
  listName,
  error,
  onChangeHandler,
  handleAdd,
}) => {
  const { selectedStore } = useSelector((store) => store.selectedStore);

  return (
    <Dialog
      size="xs"
      open={isOpen}
      handler={handleClose}
      className="bg-transparent shadow-none"
    >
      <form onSubmit={(e) => handleAdd(e)}>
        <Card className="mx-auto w-full max-w-[24rem]">
          <CardBody className="flex flex-col gap-4">
            <Typography variant="h4" color="blue-gray">
              {modalData.title}
            </Typography>
            <Typography
              className="mb-3 font-normal"
              variant="paragraph"
              color="gray"
            >
              {modalData.description}
            </Typography>

            <Input
              value={listName}
              onChange={onChangeHandler}
              label={modalData.label}
              size="lg"
            />
            {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
          </CardBody>
          <CardFooter className="flex justify-end gap-3 pt-0 ">
            <Button className="w-16 px-2 py-2 bg-red-800" onClick={handleClose}>
              {modalData.redButton}
            </Button>
            <Button
              style={{
                backgroundColor: selectedStore?.theme.backgroundColor,
              }}
              className="w-16 px-2 py-2 "
              type="submit"
            >
              {modalData.purpleButton}
            </Button>
          </CardFooter>
        </Card>
      </form>
    </Dialog>
  );
};

export default ListModal;
